// extracted by mini-css-extract-plugin
export default {"body":"style_body__ugzGL","tabContent":"style_tabContent__4YLWw","addTab":"style_addTab__15kP+"};